// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-wrapper[data-v-d1ad27d0]{position:fixed;top:3rem;bottom:0;left:0;z-index:999;width:100%;background-color:#fff;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.loading-wrapper[data-v-d1ad27d0],.show[data-v-d1ad27d0]{display:-webkit-box;display:-ms-flexbox;display:flex}.hide[data-v-d1ad27d0]{display:none}", ""]);
// Exports
module.exports = exports;
